const locationHelpers = function() {

    const getCityNameFromLocation = function (latitude, longitude, callback) {
        const geoCoder = new google.maps.Geocoder;
        geoCoder.geocode({
            'location': { lat: latitude, lng: longitude }
        }, function (results, status) {
            if (status === 'OK' && callback) {
                let cityName = getCityNameFromAddressComponents(results[0].address_components);
                callback(cityName);
            } else {
                alert("Could not resolve location");
            }
        }
        );
    }

    const getCityNameFromAddressComponents = function(addressComponents) {
        for (let i = 0; i < addressComponents.length; i++) {
            let current = addressComponents[i];
            for (let j = 0; j < current.types.length; j++) {
                if (current.types[j] === "locality" || current.types[j] === "political") {
                    return current.long_name;
                }
            }
        }
    }

    return {
        getCityNameFromLocation: getCityNameFromLocation,
        getCityNameFromAddressComponents: getCityNameFromAddressComponents
    }
}();

module.exports = locationHelpers;

